import type { AdminApiPlan } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

type AdminPlansResponse =
  | AdminApiPlan[]
  | {
      data?: AdminApiPlan[];
    };

const normalizePlans = (payload: AdminPlansResponse): AdminApiPlan[] => {
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload.data ?? [];
};

export default function useFetchAdminPlans() {
  return useQuery({
    queryKey: ['admin', 'plans'],
    queryFn: async () => {
      const response = await fetch('/admin/api/plans');
      if (!response.ok) {
        throw new Error('プラン一覧の取得に失敗しました');
      }
      const data: AdminPlansResponse = await response.json();
      return normalizePlans(data);
    },
  });
}
